export default __webpack_public_path__ + "static/media/bebemundo.6ff14ff5.png";